document.addEventListener('DOMContentLoaded', function() {
  var sections = document.querySelectorAll('[id^="vs-live-shopping-"]');

  sections.forEach(function(sectionEl) {
    var sectionId = sectionEl.id.replace('vs-live-shopping-', '');
    var config = window.VS_LIVE_CONFIG && window.VS_LIVE_CONFIG[sectionId];
    var productsMap = window.VS_LIVE_PRODUCTS && window.VS_LIVE_PRODUCTS[sectionId];

    if (!config || !productsMap) return;

    var openBtn        = sectionEl.querySelector('[data-live-open]');
    var modal          = sectionEl.querySelector('[data-live-modal]');
    var closeEls       = sectionEl.querySelectorAll('[data-live-close]');
    var video          = sectionEl.querySelector('[data-live-main-video]');
    var previewVideo   = sectionEl.querySelector('.vs-live-preview-video');
    var popupContainer = sectionEl.querySelector('[data-live-popup-container]');
    var thumbCloseBtn  = sectionEl.querySelector('[data-live-thumb-close]');
    var floating       = sectionEl.querySelector('.vs-live-floating');

    var currentChapterIndex = null;
    var intervalId = null;

    function openModal() {
      if (!modal) return;
      modal.hidden = false;
      document.documentElement.classList.add('vs-live-no-scroll');
      if (previewVideo) previewVideo.pause();
      if (video) {
        video.play().catch(function() {});
      }
      startTimer();
    }

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.classList.remove('vs-live-no-scroll');
      if (video) video.pause();
      if (previewVideo) {
        previewVideo.play().catch(function() {});
      }
      stopTimer();
      clearPopup();
    }

    function startTimer() {
      if (intervalId) return;
      intervalId = setInterval(checkTime, 1000); // checagem a cada 1s
    }

    function stopTimer() {
      if (!intervalId) return;
      clearInterval(intervalId);
      intervalId = null;
    }

    function checkTime() {
      if (!video || video.paused) return;

      var t = video.currentTime;
      var chapters = config.chapters || [];
      var newIndex = null;

      for (var i = 0; i < chapters.length; i++) {
        if (t >= chapters[i].start && t <= chapters[i].end) {
          newIndex = i;
          break;
        }
      }

      if (newIndex !== null && newIndex !== currentChapterIndex) {
        // entrou em um capítulo (ou trocou de capítulo)
        currentChapterIndex = newIndex;
        showPopupForChapter(chapters[newIndex]);
      } else if (newIndex === null && currentChapterIndex !== null) {
        // saiu de todos os capítulos
        currentChapterIndex = null;
        clearPopup();
      }
    }

    function clearPopup() {
      if (!popupContainer) return;
      popupContainer.innerHTML = '';
      popupContainer.classList.remove('vs-live-popup-visible');
    }

    function showPopupForChapter(chapter) {
      if (!popupContainer || !chapter.products || !chapter.products.length) return;

      clearPopup();

      // normaliza (trim) e pega só o primeiro produto para a preview
      var handles = (chapter.products || [])
        .map(function(h) { return (h || '').trim(); })
        .filter(Boolean)
        .slice(0, 1);

      if (!handles.length) return;

      var handle = handles[0];
      var p = productsMap[handle];
      if (!p) return;

      var html = `
        <div class="vs-live-popup">
          <div class="vs-live-product">
            <div class="vs-live-product-img">
              <img src="${p.featured_image}" alt="${p.title}">
            </div>
            <div class="vs-live-product-info">
              <div class="vs-live-product-title">${p.title}</div>
              <div class="vs-live-product-price">${p.price}</div>
            </div>
            <a href="${p.url}" class="vs-live-product-link">
              Ver produto
            </a>
          </div>
        </div>
      `;

      popupContainer.innerHTML = html;
      popupContainer.classList.add('vs-live-popup-visible');
    }

    // abrir modal
    if (openBtn) {
      openBtn.addEventListener('click', function() {
        openModal();
      });
    }

    // fechar/minimizar modal
    closeEls.forEach(function(el) {
      el.addEventListener('click', closeModal);
    });

    if (modal) {
      modal.addEventListener('click', function(e) {
        if (e.target.hasAttribute('data-live-close')) {
          closeModal();
        }
      });
    }

    // fechar thumb (preview flutuante)
    if (thumbCloseBtn && floating) {
      thumbCloseBtn.addEventListener('click', function(e) {
        e.stopPropagation(); // não dispara o openModal
        floating.style.display = 'none';
        if (previewVideo) previewVideo.pause();
      });
    }
  });
});
